import React from 'react';
import { BrowserRouter, Switch } from 'react-router-dom';
import ScrollToTop from 'components/public/scrollToTop/scrollToTop';
import ErrorHandler from 'components/public/errorHandler/index';
import RoutesList from './routesList';

import 'common/less/base.less';

class RouterMap extends React.PureComponent {

    componentDidMount() {
		document.title = '';
	}

	componentDidUpdate() {

	}

	render() {
		return (
			<BrowserRouter>
				<ErrorHandler>
					<ScrollToTop>
						<Switch>
							{RoutesList}
						</Switch>
					</ScrollToTop>
				</ErrorHandler>
            </BrowserRouter>
        );
	}
}

export default RouterMap;




// WEBPACK FOOTER //
// ./src/router/thefair/routeMap.js